import { useSelector } from "react-redux";

export default function useSelectedSection() {
    const selected = useSelector(state => state.event.tickets.section);
    const { sections, loading} = useSelector(state => state.event.maps.sections);
    if (!selected || loading) {
        return null;
    }
    return sections[selected];
}